import React from "react";
import "./css/Copyright.scss";

function Copyright() {
  return (
    <div className="Copyright">
      <p>
        2026 © Hutaib Industrial Solutions | Designed by <a href="https://artxpro.com/" target='_blank'> artxpro</a>
      </p>
    </div>
  );
}

export default Copyright;
